// src/constants/const.js

// export const menuItems = (country_name = "Germany") => [
//   { label: "GLAPSOL", path: "/" },
//   { label: `${country_name} Overview`, path: `/about` },
//   { label: `Study in ${country_name}`, path: "/study-programs" },
//   { label: `Course Finder`, path: "/course-finder" },
//   { label: "Education Loan Support", path: "/finance-support" },
//   { label: `Blocked Account (${country_name})`, path: "/block-open-account" },
//   { label: "Forex & International Payments", path: "/forex-service" },
//   { label: `Accommodation in ${country_name}`, path: "/find-accommodation" },
//   { label: "Visa Application Process", path: "/book-visa-appointment" },
//   { label: "Biometrics Appointment Booking", path: "/prepare-visa-file" },
//   { label: `Part-Time Jobs in ${country_name}`, path: "/part-time-jobs" },
// ];

export const menuItems = (country_name = "Germany") => [
  { label: "GLAPSOL", path: "/" },
  { label: `${country_name} Overview`, path: `/about` },
  {
    label: `Study in ${country_name}`,
    path: "/study-programs",
    activePaths: ["/study-programs", "/offer"],
  },
  {
    label: `Course Finder`,
    path: "/course-finder",
    activePaths: ["/course-finder", "/program"],
  },
  { label: `Blocked Account`, path: "/block-open-account" },
  { label: "Education Loan Support", path: "/finance-support" },
  { label: "Forex & International Payments", path: "/forex-service" },
  { label: `Accommodation`, path: "/find-accommodation" },
  { label: "Visa Application Process", path: "/book-visa-appointment" },
  { label: "Biometric Appointment Booking", path: "/prepare-visa-file" },
  {
    label: `Part-Time Jobs`,
    path: "/part-time-jobs",
    activePaths: ["/part-time-jobs", "/details"],
  },
];
